import * as React from "react";
import ExternalLink from "~/components/Navigation/ExternalLink";
import styles from "./Registrations.module.less";
export const CommonBuildServerPackagingTextForIntegration = (<React.Fragment>
        <h4>Build Server Integration</h4>
        <p>
            Please see the <ExternalLink href="PackagingApiAndIntegration">API and Integrations</ExternalLink> documentation to learn more about integration with your build server.
        </p>
    </React.Fragment>);
export const CommonTextForOctopusCli = (<React.Fragment>
        <h4>Octopus CLI</h4>
        <p>
            <ExternalLink href={"cli"} label={"Octopus CLI"}>
                Octopus CLI
            </ExternalLink>{" "}
            is our API command line tool that allows you to interact with your Octopus Deploy server using different commands, one of which is the <code>package (nuget|zip) create</code> command which can turn any ordinary folder into a NuGet or Zip
            package.
        </p>
    </React.Fragment>);
export const CommonCommandLineTextForOctopusCliCodeSample = (<React.Fragment>
        <div className={styles.codeContainer}>
            For example:
            <br />
            <code>octopus package zip create --id SomePackage --version 1.0.0 --base-path "folder/to/pack" --out-folder "destination/folder/path"</code>
        </div>
    </React.Fragment>);
export const CommonManualPackagingTextForNuGet = (<React.Fragment>
        <h4>NuGet Packages</h4>
        <p>
            The simplest way to create a NuGet package is using the <ExternalLink href="PackagingCreatingNuGetPackagesManually">NuGet Package Explorer</ExternalLink>.
        </p>
        <p>
            Alternatively, NuGet packages can easily be created using the{" "}
            <ExternalLink href={"cli"} label={"Octopus CLI"}>
                Octopus CLI
            </ExternalLink>
            .
        </p>
    </React.Fragment>);
export const CommonManualPackagingTextForZip = (<React.Fragment>
        <h4>Zip Packages</h4>
        <p>
            Octopus supports Zip files as packages, as created through common Zip programs or with the{" "}
            <ExternalLink href={"cli"} label={"Octopus CLI"}>
                Octopus CLI
            </ExternalLink>
            .
        </p>
        <ul>
            <li>
                Learn more about <ExternalLink href="PackagingCreatingPackages">Creating Packages</ExternalLink>
            </li>
            <li>
                Learn more about <ExternalLink href="PackagingCreatingSupportedPackages">Supported Formats</ExternalLink>
            </li>
            <li>
                Learn more about <ExternalLink href="PackagingCreatingPackageIds">Package IDs</ExternalLink>
            </li>
            <li>
                Learn more about <ExternalLink href="PackagingCreatingVersioning">Versioning</ExternalLink>
            </li>
        </ul>
    </React.Fragment>);
export const CommonTextForJavaSample = (<React.Fragment>
        <p>
            The Octopus library accepts files with the <code>jar</code>, <code>war</code>, <code>ear</code> and <code>rar</code> file extensions. The package filenames have to adhere to the standard Octopus versioning rules, which are based on the
            SemVer format.
        </p>
        <p>
            We also have a <ExternalLink href="PackagingDeploymentExamplesJava">sample project walkthrough</ExternalLink> where you can see examples of Java packaging.
        </p>
    </React.Fragment>);
